export default {
  name: 'PageLoading',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
};